import React, { useEffect, useMemo } from 'react';
import { Dialog, Input, Select } from 'tdesign-react';
import { find } from 'lodash';
import { connect } from 'react-redux';
import {
  flowGroupRuleOptions,
  flowNodeTaskOptions,
  flowGroupRuleOptionsScript,
  stencilTypeOptions,
  systemNodeTaskOptions,
} from '@/utils/constant';
import { toTsOptions } from '@/utils/common';
import Form from '@/components/Form';

const { FormItem } = Form;

const choiceTypeOptions = [
  {
    label: '手动选择',
    value: 1,
  },
  {
    label: '自动选择',
    value: 2,
  },
];

function FormModal({
  handleClose,
  visible,
  componentOptions,
  scriptOptions,
  groupOptions,
  flowType,
}) {
  const [form] = Form.useForm();

  // 节点类型
  const type = Form.useWatch('type', form);
  // 选择方式
  const choiceType = Form.useWatch('choiceType', form);

  const taskOptions = useMemo(() => {
    switch (type) {
      case 0:
        return flowGroupRuleOptionsScript;
      case 1:
        return flowNodeTaskOptions;
      case 2:
        return systemNodeTaskOptions;
      default:
        return [];
    }
  }, [type]);

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleSubmit = async (fields) => {
    const values = {
      ...fields,
      stencilId: fields.name,
    };
    if (values.type === 0) {
      values.stencilTxt = values.name = find(scriptOptions, { value: fields.name }).label;
    }
    if (values.type === 1) {
      values.stencilTxt = values.name = find(componentOptions, { value: fields.name }).label;
    }

    if (values.type === 2) {
      delete values.stencilId;
    }

    handleClose(values);
  };

  const onTypeChange = () => {
    form.setFieldsValue({
      name: null,
      task: null,
    });
  };

  return (
    <Dialog
      onClose={() => handleClose()}
      visible={visible}
      header='新建节点'
      onConfirm={() => form.submit()}
    >
      <Form style={{ width: '90%' }} form={form} onFinish={handleSubmit}>
        <FormItem name='type' label='节点类型' rules={[{ required: true }]}>
          <Select options={toTsOptions(stencilTypeOptions)} onChange={onTypeChange} />
        </FormItem>
        <FormItem name='task' label='节点任务' rules={[{ required: true }]}>
          <Select options={toTsOptions(taskOptions)} />
        </FormItem>
        {type === 0 && (
          <FormItem name='name' label='节点名称' rules={[{ required: true }]}>
            <Select options={toTsOptions(scriptOptions)} />
          </FormItem>
        )}
        {type === 1 && (
          <FormItem name='name' label='节点名称' rules={[{ required: true }]}>
            <Select options={toTsOptions(componentOptions)} />
          </FormItem>
        )}
        {type === 2 && (
          <>
            <FormItem name='name' label='节点名称' rules={[{ required: true }]}>
              <Input placeholder='请输入' />
            </FormItem>
            <FormItem name='path' label='文件路径' rules={[{ required: true }]}>
              <Input placeholder='上传文件到目标机器的路径' />
            </FormItem>
            <FormItem name='fileName' label='文件名修改为'>
              <Input placeholder='如果为空取上传文件名' />
            </FormItem>
          </>
        )}

        {/* 虚拟机 */}
        {flowType === 0 && (
          <>
            <FormItem name='choiceType' label='选择方式' rules={[{ required: true }]}>
              <Select options={toTsOptions(choiceTypeOptions)} />
            </FormItem>
            {choiceType === 1 && (
              <>
                <FormItem name='groupId' label='主机组' rules={[{ required: true }]}>
                  <Select options={toTsOptions(groupOptions)} />
                </FormItem>
                <FormItem name='groupRule' label='执行规则' rules={[{ required: true }]}>
                  <Select options={toTsOptions(flowGroupRuleOptions)} />
                </FormItem>
              </>
            )}
          </>
        )}
      </Form>
    </Dialog>
  );
}

export default connect((state) => ({
  groupOptions: state.template.currentFlowGroups.map((item) => ({
    label: item.name,
    value: item.id,
  })),
}))(FormModal);
